import { type SuretyQuoteId, suretyQuoteId } from "@inrev/common";
import { bondRequestRedirectQueryKey } from "@portal/api/bond-request";
import type { AdminBondRequest } from "@portal/api/bond-request/admin/types";
import { LoadingModal } from "@portal/components/layout/LoadingModal";
import { useQuery } from "@tanstack/react-query";
import type { FC } from "react";
import { useEffect } from "react";
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import { useRequest } from "../../../utils/request";

const AdminBondRequestRedirectContent: FC<{ quoteId: SuretyQuoteId }> = ({ quoteId }) => {
	const navigate = useNavigate();
	const { search } = useLocation();
	const { get } = useRequest();

	const { data: bondRequest, error } = useQuery({
		queryKey: bondRequestRedirectQueryKey(quoteId),
		queryFn: async () => await get<AdminBondRequest>(`/v2/admin/surety/quotes/${quoteId}`),
		retry: false,
	});

	useEffect(() => {
		if (bondRequest) {
			navigate(`/accounts/${bondRequest.suretyAccountId}/requests/${bondRequest.id}${search}`, {
				replace: true,
			});
		}
	}, [bondRequest, navigate, search]);

	useEffect(() => {
		if (error) {
			navigate("/requests", { replace: true });
		}
	}, [error, navigate]);

	return <LoadingModal />;
};

export const AdminBondRequestRedirect = () => {
	const params = useParams();
	const quoteIdResult = suretyQuoteId.safeParse(params.id);

	if (!quoteIdResult.success) {
		return <Navigate to="/requests" replace />;
	}

	return <AdminBondRequestRedirectContent quoteId={quoteIdResult.data} />;
};
